export default __webpack_public_path__ + "static-front/media/UserIcon.d9f22f6e.svg";